import React, { useState } from 'react';
import './project.css';

const Project = ({imgUrl, date, title, url, video}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleWatchDemo = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleLearnMore = () => {
    if (url) {
      window.open(url, '_blank');
    }
  };

  return (
    <div className='my__projects-project'>
      <div className='my__projects-project-image'>
        <img src={imgUrl} alt='blog' />
      </div>
      <div className='my__projects-project-content'>
        <div>
          <p>{date}</p>
          <h3>{title}</h3>
        </div>
        <div className='my__projects-project-actions'>
          {url && (
            <button onClick={handleLearnMore}>Learn More</button>
          )}
          {video && (
            <button onClick={handleWatchDemo}>Watch Demo</button>
          )}
        </div>
      </div>

      {/* Video Modal */}
      <div className={`video-modal-overlay ${isModalOpen ? 'open' : ''}`} onClick={handleCloseModal}>
        <div className='video-modal-content' onClick={(e) => e.stopPropagation()}>
          <button className='video-modal-close' onClick={handleCloseModal}>×</button>
          {video && <video controls autoPlay><source src={video} type='video/mp4' /></video>}
        </div>
      </div>
    </div>
  )
}

export default Project